<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-nav="false" @backClick="back" nav-title="新增案例">
    <div class="o-y-auto" style="background-color: #F4F8FF;height: calc(100% - 40px)">
      <div class="w-full" style="min-height: calc(100% - 64px)">
        <div class="m-auto bg-white" style="width: 820px;min-height: calc(100% - 1px);">
          <div class="p-20">
            <Row :gutter="15">
              <Col span="12">
                <class-vertical-choose-widget :objData="objData" :srcType="8" direction="horizontal"
                                              leftLabelText="案例分类"
                                              rightLabelText="案例分组">

                </class-vertical-choose-widget>
              </Col>
              <Col span="12">
                <div class="fs-14 bold">关联商品：</div>
                <Input :value="getGoodsName" @on-clear="onInputClearClick" class="p-t-10 " clearable placeholder="关联商品"
                       readonly>
                  <template #append>
                    <Button @click="onProductChooseClick" icon="md-add" style="width: 50px"></Button>
                  </template>
                </Input>
              </Col>
            </Row>
          </div>
          <Input class=" p-h-20 " placeholder="案例标题" maxlength="32" v-model="title"></Input>
          <Input :rows="4" class=" p-t-15 fs-14  p-h-20" placeholder="案例内容" type="textarea" v-model="content"></Input>

          <div class="fs-14 bold p-t-15 p-h-20">案例详情：</div>
          <div
            style="min-height: 400px; margin-left: 20px;margin-bottom: 74px;padding-bottom:20px;display: flex;flex-wrap: wrap;flex-direction: column">
            <ul>
              <li class=" clear" style="float:left;margin-right: 15px;margin-top: 20px;"
                  v-if="!(imageList && imageList.length)">
                <video-edit-test2
                  :always-show-upload="true"
                  :coverEnable="coverEnable"
                  :hasPathProName=false
                  :height="145 + 'px'"
                  :videoinfo="videoinfos" :vidupload="false" :width="182 + 'px'"
                  @configvideoclick="onvideoClick"
                  @onConfigCancelClick="showVideoEdit=false"
                  @uploadVideoSuccess="uploadVideoSuccess"
                  videoInfix="bbs/content/"/>
              </li>

              <li class="clear" style="float:left;margin-right: 15px;margin-top: 20px;"
                  v-if="!videoinfos.videoUrl">
                <up-load-image :hasPathProName=false @uploadSuccess="uploadDescImageSuccess"
                               accept="image/*"
                               multiple
                               picurl="bbs/effect/"
                               style="width:182px;height: 145px;">
                  <template v-slot:tip>
                    <div style="width: 182px;">
                      <div class="flex-column a-center j-center  m-b-10"
                           style="width: 182px;height: 145px;background-color: #F6F9FF;cursor: pointer">
                        <img alt="" src="../../../assets/common/ic_upload_picture@2x.png"
                             style="width: 64px;height: 64px">
                        <span class="m-t-5  color-66">上传图片</span>
                      </div>
                    </div>
                  </template>
                </up-load-image>
              </li>

              <li class=" clear" style="float:left;margin-right: 15px;margin-top: 20px;"
                  v-if="videoinfos.localUrl||videoinfos.videoUrl || videoinfos.videoAliVid">

                <div :style="{width:width,height:height}" class="video-style relative"
                     style="width: 182px;height:145px;">
                  <div :style="{width:width,height:height}" class="relative" style="width: 182px;height:145px; "
                       v-show="getvideourl">
                    <video :src="getvideourl" :style="{height:height,width: width}" alt=""
                           id="video-sid"
                           style="object-fit: fill"/>
                    <img :src="videoinfos.imgUrl" :style="{width:width,height:height}" alt=""
                         class="absolute top-0 left-0"
                         style="width: 182px;height:145px; "
                         v-if="getvideourl && videoinfos.imgUrl">
                    <img class="play-img-style"
                         src="../../../assets/common/ic_shipinbiaozhi_white@2x.png"
                         v-if="getvideourl && videoinfos.imgUrl">
                  </div>
                  <video-player :poster="videoinfos.imgUrl" :style="{width:width,height:height}"
                                :vid="videoinfos.videoAliVid"
                                aspectRatio="16:9"
                                ref="players"
                                style="width: 182px;height:145px; "
                                v-show="videoinfos.videoAliVid && !videoinfos.localUrl && !videoinfos.videoUrl"/>
                  <div :style="{width:width,height:height}" @click.stop="onButtomClick"
                       class="absolute top-0 "
                       style="width: 182px;height:145px; background-color: #00000040;cursor: pointer;"
                       v-if="videoinfos.localUrl ||videoinfos.videoUrl || videoinfos.videoAliVid "></div>
                  <p @click="onDeleteVideo()" class="delete-style" style="top: -7px;right: -7px;"
                     v-if="videoinfos.localUrl||videoinfos.videoUrl || videoinfos.videoAliVid"><span
                    class="delete-inner"></span></p></div>
              </li>

              <draggable :move="onMove"
                         :options="dragOptions1"
                         @end="isDragging=false"
                         @start="isDragging=true"
                         element="ul"
                         v-model="imageList">
                <li :key="index" class="clear"
                    style="float: left;margin-right: 15px;margin-top: 20px"
                    v-for="(item,index) in imageList">
                  <div class="border  relative hoverstyle" style="width:182px;height: 145px;">
                    <div class="w-full o-hidden" style="height: 145px;">
                      <img :src="item.url" alt="" class="w-full v-a-center"
                           style="object-fit: fill;width: 100%;height: 145px">
                    </div>
                    <div @click="onItemDel(imageList,index)" class="showdel"
                         style="position: absolute;top: -10px;right: -10px">
                      <i class="icon-delete_small fs-20"
                         style="color: #F44336;cursor: pointer"/>
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
          </div>
        </div>
      </div>

      <div class="m-auto bg-white flex a-center j-end"
           style="width: 820px;position: sticky;bottom: 0;left: 0;height: 64px;box-shadow: 0 0 8px 0 rgba(1, 0, 52, 0.12);">
        <Button @click="goBack" style="width: 76px">取消</Button>
        <Button @click="onSaveClick" class="m-l-20" style="margin-right: 38px;width: 76px" type="primary">保存</Button>
      </div>

    </div>
    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>
    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onModalProductChooseClose"
           class="prewmodal"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showprochoose"
           width="1200">
      <product-choose-widget :multiSelect="false" :open="showprochoose" :selectedRows="selectedRows"
                             @cancel="showprochoose=false"
                             @ok="onProductSave"></product-choose-widget>
    </Modal>
  </base-page-component>


</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import draggable from 'vuedraggable'
import UpLoadVideo from '@/components/common/UpLoadVideo'
import VideoPlayer from '@/components/common/VideoPlayer'
import videoEditTest2 from '@/components/common/VideoEditTest2'
import VideoPrew from '@/components/common/VideoPrew'
import ClassVerticalChooseWidget from '../../../components/common/ClassVerticalChooseWidget'
import {mapActions, mapMutations} from 'vuex'
import ProductChooseWidget from '../../../components/product/ProductChooseWidget'

export default {
  name: 'NewExample',
  components: {
    ProductChooseWidget,
    ClassVerticalChooseWidget,
    BasePageComponent,
    UpLoadImage,
    UpLoadVideo,
    videoEditTest2,
    VideoPlayer,
    VideoPrew,
    draggable,
  },
  data () {
    return {
      coverEnable: true,
      width: '182px',
      height: '145px',
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      title: '',
      content: '',

      showprochoose: false,
      // goodsId: 0,               //关联商品
      // goodsName: '',              //关联商品名称

      isDragging: false,
      imageList: [],            // 图片列表
      process: '',
      videoinfos: {  //视频信息
        id: 0,            //这条视频在后台库的Id
        videoAliVid: '',  //阿里云路径
        localUrl: '',     //本地路径
        videoUrl: '',     //Oss视频路径
        videoTitle: '',   //视频标题
        imgUrl: '',       //视频封面
        videoTime: '',    //视频时长
        videoSize: '',    //视频大小
        videoDesc: ''     //视频描述
      },
      videoprewinfo: {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      },
      showVideoPrew: false,
      selectProductObjs: [],
      selectedRows: []
    }
  },
  computed: {
    dragOptions1 () {    //拖动参数
      return {
        animation: 0,
        group: {
          name: 'description',
          // pull: 'clone',
          // put: false
        },
        scroll: true,
        ghostClass: 'ghost',
        scrollSensitivity: 30,
        forceFallback: false,
        disabled: false
      }
    },
    getvideourl () {
      if (this.videoinfos.localUrl) {
        console.log(this.videoinfos.localUrl)
        return this.videoinfos.localUrl
      }
      if (this.videoinfos.videoUrl) {
        console.log(this.videoinfos.videoUrl)
        return this.videoinfos.videoUrl
      }
      return ''
    },
    getGoodsName () {
      let text = ''
      if (this.selectProductObjs && this.selectProductObjs.length) {
        text = this.selectProductObjs.map(res => {
          return res.name
        }).join(',')
      }
      return text
    }
  },

  mounted () {
    this.init()
  },
  activated () {
    if (this.$route.query.id) {
      this.selectProductObjs = [{
        id: parseInt(this.$route.query.id || 0),
        name: this.$route.query.name || ''
      }]
    }
  },
  methods: {
    init () {

    },
    back () {
      window.history.back()
    },
    onMove ({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    /**
     * 图片删除处理
     * @param arrayList
     * @param index
     */
    onItemDel (arrayList, index) {
      arrayList.splice(index, 1)
    },
    /**
     *上传图片
     * @param data
     */
    uploadDescImageSuccess (data) {
      if (data && data.length) {
        let list = data.map(res => {
          return {
            url: res.url,
            width: res.width,
            height: res.height,
            title: res.oldname || ''
          }
        })
        this.imageList = this.imageList.concat(list)
      }
    },
    onVideoUpload (data) {
      this.process = Number.parseInt(data * 100) + '%'
    },
    onDeleteVideo () {
      this.videoinfos = {
        videoAliVid: '',
        videoUrl: '',
        localUrl: '',
        videoTitle: '',
        imgUrl: '',
        videoTime: '',
        videoSize: '',
        videoDesc: '',
      }
    },
    onButtomClick () {
      let item = this.videoinfos
      if (item.videoUrl || item.videoAliVid) {
        this.videoprewinfo = {
          videoUrl: item.videoUrl || '',
          videoAliVid: item.videoAliVid || '',
          coverUrl: item.imgUrl,
          videoTitle: item.videoTitle
        }
        this.showVideoPrew = true
      }
    },
    getTitleByFiles (localfile) {
      let filename = ''
      if (localfile && localfile.name) {
        filename = localfile.name.split('.')[0]
      }
      return filename
    },
    uploadImageStart () {
    },
    uploadVideoSuccess (data) {
      this.videoinfos.videoAliVid = data[0].videoId
      this.videoinfos.localUrl = data[0].localUrl
      this.videoinfos.videoUrl = data[0].videoUrl
      this.videoinfos.videoSize = data[0].localfile.size
      if (!this.videoinfos.videoTitle) {
        this.videoinfos.videoTitle = this.getTitleByFiles(data[0].localfile)
      }
      this.process = ''
    },
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    goBack () {
      this.$router.go(-1)
      this.closeTag({
        name: 'NewExample'
      })
    },
    onSaveClick () {
      // if (!this.title) {
      //   return this.$Message.info('请输入案例标题')
      // }
      let imageList = this.imageList.map((child, index) => {
        return {
          id: 0,
          type: 1,
          imgUrl: child.url || '',
          videoUrl: '',
          width: child.width || 0,
          height: child.height || 0,
          length: 0,
          title: child.title || '',
          desc: '',
          extension: '',
          jumpLink: '',
          sort: index + 1
        }
      })

      let videoList = []
      if (this.videoinfos.videoUrl) {
        let video = document.getElementById('video-sid')
        let duration = 0
        let width = 0
        let height = 0
        if (video && (this.videoinfos.localUrl || this.videoinfos.videoUrl)) {
          duration = video.duration
          width = video.videoWidth
          height = video.videoHeight
        }
        videoList = [{
          id: 0,
          type: 2,
          imgUrl: '',
          videoUrl: this.videoinfos.videoUrl || '',
          width: width || 0,
          height: height || 0,
          length: duration || 0,
          title: this.videoinfos.videoTitle || '',
          desc: this.videoinfos.videoDesc || '',
          extension: '',
          jumpLink: '',
          sort: 1
        }]
      }

      let imglen = imageList.length || 0
      let videolen = videoList.length || 0
      if (!(imglen || videolen || this.content)) {
        return this.$Message.info('请完善案例内容')
      }

      let params = {
        categoryId: this.objData.classId,
        groupId: this.objData.groupId,
        type: 2,
        title: this.title,
        content: this.content,
        imgList: imageList || [],
        videoList: videoList || [],
      }

      if (this.selectProductObjs && this.selectProductObjs.length) {
        params.goodsList = this.selectProductObjs.map(res => {
          return {
            id: res.id
          }
        })
      } else {
        params.goodsList = []
      }

      this.addbbs(params).then(res => {
        if (res.code === 0) {
          this.goBack()
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    onvideoClick () {

    },
    onModalProductChooseClose (status) {
      if (!status) {

      }
    },
    onProductChooseClick () {
      this.selectedRows = JSON.parse(JSON.stringify(this.selectProductObjs))
      this.showprochoose = true
    },
    onProductSave (list) {
      if (list && list.length) {
        this.selectProductObjs = list
      } else {
        this.selectProductObjs = []
      }
      this.showprochoose = false
    },
    onInputClearClick () {
      this.selectProductObjs = []
    },
    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'addbbs'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .hoverstyle {
    &:hover {
      .showdel {
        display: block;
      }
    }

    .showdel {
      display: none;
    }
  }


</style>
<style scoped>
  .prewmodal >>> .ivu-modal-body {
    padding: 0;
  }
</style>
